
import React, { useEffect, lazy, Suspense } from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import { FloatingContact } from '@/components/MessengerLinks';
import { setupScrollPrefetch } from '@/utils/prefetch';

// Lazy load components that are not immediately visible
const servicesImport = () => import('@/components/Services');
const aboutImport = () => import('@/components/About');
const reviewsImport = () => import('@/components/Reviews');
const contactImport = () => import('@/components/Contact');
const footerImport = () => import('@/components/Footer');

const Services = lazy(servicesImport);
const About = lazy(aboutImport);
const Reviews = lazy(reviewsImport);
const Contact = lazy(contactImport);
const Footer = lazy(footerImport);

export default function Home() {
  // Set up prefetching of components when user starts scrolling
  useEffect(() => {
    // Start prefetching components when user has scrolled 20% of the viewport
    const cleanup = setupScrollPrefetch(0.2, [
      servicesImport,
      aboutImport,
      reviewsImport,
      contactImport,
      footerImport
    ]);

    return cleanup;
  }, []);

  // Simple fallback for lazy-loaded components
  const LoadingFallback = () => (
    <div className="flex justify-center items-center py-20">
      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
    </div>
  );

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Suspense fallback={<LoadingFallback />}>
        <Services />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <About />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <Reviews />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <Contact />
      </Suspense>
      <Suspense fallback={<LoadingFallback />}>
        <Footer />
      </Suspense>
      <FloatingContact />
    </div>
  );
}
